import { Input, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { ElementRef } from '@angular/core';
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  Form,
  FormElement,
  ViewState,
  AppTableComponent,
  MessagesComponent,
  FormElementValidators,
  Auth,
  TranslationEntityComponent,
  SearchModel, SearchResultModel
} from 'src/common';
import { SupplierRoundListModel, SupplierRoundListService } from 'src/common';
import { TranslationManager } from 'src/common/translation';


@Component({
  selector: 'app-supplier-round-list-ssy1230detail',
  templateUrl: 'supplier-round-list-ssy1230detail.component.html'
})
export class SupplierRoundListSsy1230detailComponent implements OnInit, AfterViewInit {

  @ViewChild(AppTableComponent) appTable: AppTableComponent;


  @Input() state: ViewState;
  viewState = ViewState;
  form: Form = new Form();
  translationManager = TranslationManager;
  @ViewChild('translationEntitySupplierRoundListName') translationEntitySupplierRoundListName: TranslationEntityComponent;

  procurementModelUniqueIdentifier: string;



  // custom-constructor-start

  translationEntityDisplay = false;

  constructor(private router: Router, public route: ActivatedRoute, private el: ElementRef, private supplierRoundListService: SupplierRoundListService) { }




  // custom-constructor-end

  ngAfterViewInit(): void {
    this.DisableTranslationLang();
  }
  ngOnInit(): void {

    if (this.state == ViewState.Create) {
      //   Auth.checkAuthorization('08FF6319-37B9-4EF7-8637-51A0F670EC18');
    } else if (this.state == ViewState.Details) {
      //  Auth.checkAuthorization('59F4080C-537A-43D5-8922-57BE1CBC3744');
    } else if (this.state == ViewState.Edit) {
      //    Auth.checkAuthorization('CC2D49D2-E408-4551-B15E-236F57D344FE');
    }

    this.initForm();
    if (this.state === ViewState.Edit || this.state === ViewState.Details) {
      this.form.elements['id'].value = this.route.snapshot.params.id;
      let search1 = new SearchModel();
      search1.filters.push({ 'entity': "RequestRoundSupplierId", 'value': this.form.elements['id'].value + '', 'action': "equals" });
      this.supplierRoundListService.search(search1).then((result: SearchResultModel<SupplierRoundListModel>) => {
        let items1 = result.items;
        this.procurementModelUniqueIdentifier = items1[0].procurementModelUniqueIdentifier;
        this.bindModelToForm(items1[0]);
      }).catch((reason: any) => {
        if (reason !== null) {
          if (reason.status === 400) {
            if (reason.error !== null) {
              if (reason.error.message) {
                const mescustom = reason.error.message;
                MessagesComponent.instance.showError([mescustom]);

              }
            }
          }
        }

      });
    }
  }


  private initForm(): void {
    this.initFormCustom();
  }

  private DisableTranslationLang(): void {
    const childNodes = document.querySelectorAll("#containerLangDetails select, #containerLangDetails input, #containerLangDetails textarea, #containerLangDetails button")[Symbol.iterator]() || null;
    if (childNodes) {
      for (var node of childNodes) {
        node.disabled = true;
      }
    }
  }

  private bindModelToForm(item: SupplierRoundListModel): void {
    this.bindModelToFormCustom(item);
  }



  fillModel(model) {
    model['id'] = this.form.elements['id'].value;
    model['requestRoundId'] = this.form.elements['requestRoundId'].value;
    model['requestId'] = this.form.elements['requestId'].value;
    model['requestName'] = this.form.elements['requestName'].value;
    model['requestDeadline'] = this.form.elements['requestDeadline'].value;
    model['requestSupplierDeadline'] = this.form.elements['requestSupplierDeadline'].value;
    model['requestRoundStatusName'] = this.form.elements['requestRoundStatusName'].value;
    model['auctionStartDate'] = this.form.elements['auctionStartDate'].value;
    model['auctionDuration'] = this.form.elements['auctionDuration'].value;
    if (this.translationEntityDisplay) {
      model.translationName = this.translationEntitySupplierRoundListName.entity;
    }

  }

  initFormCustom() {
    this.form.elements["id"] = new FormElement();
    this.form.elements['requestRoundId'] = new FormElement();
    this.form.elements['requestRoundId'].state.mandatory = true;
    this.form.elements['requestId'] = new FormElement();
    this.form.elements['requestId'].state.mandatory = true;
    this.form.elements['requestName'] = new FormElement();
    this.form.elements['requestName'].state.mandatory = false;
    this.form.elements['requestDeadline'] = new FormElement();
    this.form.elements['requestDeadline'].state.mandatory = false;
    this.form.elements['requestSupplierDeadline'] = new FormElement();
    this.form.elements['requestSupplierDeadline'].state.mandatory = false;
    this.form.elements['requestRoundStatusName'] = new FormElement();
    this.form.elements['requestRoundStatusName'].state.mandatory = false;
    this.form.elements['auctionStartDate'] = new FormElement();
    this.form.elements['auctionStartDate'].state.mandatory = false;
    this.form.elements['auctionDuration'] = new FormElement();
    this.form.elements['auctionDuration'].state.mandatory = false;

  }

  bindModelToFormCustom(item) {
    this.form.elements['id'].value = item.id;
    this.form.elements['requestRoundId'].value = item.requestRoundId;
    this.form.elements['requestId'].value = item.requestId;
    this.form.elements['requestName'].value = item.requestName;
    this.form.elements['requestDeadline'].value = item.requestDeadline;
    this.form.elements['requestSupplierDeadline'].value = item.requestSupplierDeadline;
    this.form.elements['requestRoundStatusName'].value = item.requestRoundStatus;
    this.form.elements['auctionStartDate'].value = item.auctionStartDate;
    this.form.elements['auctionDuration'].value = item.auctionDuration;
    if (item['translationName']) {
      this.translationEntitySupplierRoundListName.entity = item['translationName'];
    }
  }

  navigateToList(): void {
    this.router.navigate(['../supplier-rounds']);
  }

  submit(): void {

    if (this.form.isValid() && (!this.translationEntityDisplay || this.translationEntitySupplierRoundListName.isValid())) {
      const model: SupplierRoundListModel = new SupplierRoundListModel();

      this.fillModel(model);

      if (this.state === ViewState.Create) {

        this.supplierRoundListService.save(model).then(() => {
          MessagesComponent.instance.showSuccess([this.translationManager.getTranslation('Успешно сачуван ентитет')]);
          this.router.navigate(['supplier-round-list']);
        }).catch((reason: any) => {
          // MessagesComponent.instance.showError(reason.error.messages);
          if (reason !== null) {
            if (reason.status === 400) {
              if (reason.error !== null) {
                if (reason.error.message) {
                  const mescustom = reason.error.message;
                  MessagesComponent.instance.showError([mescustom]);

                }
              }
            } else {
              MessagesComponent.instance.showError(reason.error.messages);
            }
          }
        });
      } else if (this.state === ViewState.Edit) {
        this.supplierRoundListService.save(model).then(() => {
          MessagesComponent.instance.showSuccess([this.translationManager.getTranslation('Успешно измењен ентитет')]);
          this.router.navigate(['supplier-round-list']);
        }).catch((reason: any) => {
          if (reason !== null) {
            if (reason.status === 400) {
              if (reason.error !== null) {
                if (reason.error.message) {
                  const mescustom = reason.error.message;
                  MessagesComponent.instance.showError([mescustom]);
                }
              }
            } else {
              MessagesComponent.instance.showError(reason.error.messages);
            }
          }
        });
      }
    }
  }

}
